module.exports = __webpack_public_path__ + "fonts/TheFontGatsby.9124829d.woff2";